export default "__VITE_ASSET__CLH6k2ZI__"